import { Location } from 'history';
import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { getRouterState } from '../../../global/selectors';
import { LocationState } from '../../../global/types';
import { defaultSortOrder } from '../constants';
import { InventorySortOrder } from '../types';

type InventoryQueryParams = {
  location: Location<LocationState>;
  locationState: LocationState;
  search: string;
  sortOrder: InventorySortOrder;
  start: number;
};

const parseInventorySortOrder = (sort: string): InventorySortOrder => {
  const sortOrders = Object.values(InventorySortOrder);
  return sortOrders.includes(sort as InventorySortOrder)
    ? (sort as InventorySortOrder)
    : defaultSortOrder;
};

const useInventoryQueryParams = (): InventoryQueryParams => {
  const { location } = useSelector(getRouterState);
  const parsed = queryString.parse(location.search);
  const start: number = parsed.start ? parseInt(parsed.start.toString(), 10) : 0;
  const search: string = parsed.search ? parsed.search.toString() : '';
  const sortOrder = parseInventorySortOrder(parsed.sort ? parsed.sort.toString() : '');
  const { state } = location;

  return {
    location,
    locationState: state,
    search,
    sortOrder,
    start,
  };
};

export default useInventoryQueryParams;
